import styles from "./CallToActionButton.module.css";

export enum LeadFormButtonVariant {
    fullWidthWithFields,
    fullWidthWithoutFields,
    inlineWithFields,
}

type ActionButtonType = ({
    buttonText,
    buttonPrivacyText,
    variant,
    disabled
}: {
    buttonText: string;
    buttonPrivacyText?: string;
    variant?: LeadFormButtonVariant;
    isLoading?: boolean;
    disabled?: boolean;
}) => React.ReactElement;

export const CallToActionButton: ActionButtonType = (props) => {
    const { buttonText, buttonPrivacyText } = props;

    let buttonOnly = false;
    const containerClasses = [];
    const buttonClasses = [styles.button];

    switch (props.variant) {
        case LeadFormButtonVariant.fullWidthWithFields:
            containerClasses.push(styles.callToActionSection);
            buttonClasses.push(
                styles.callToActionButton,
                styles.fullWidthCallToActionButton
            );
            break;
        case LeadFormButtonVariant.inlineWithFields:
            buttonClasses.push(styles.inlineButton);

            break;
        case LeadFormButtonVariant.fullWidthWithoutFields:
            containerClasses.push(styles.callToActionSection);
            buttonClasses.push(styles.callToActionButton);
            buttonOnly = true;
            break;
    }

    return (
        <div className={containerClasses.join(" ")}>
            {/* If we are in "button only" mode, then the button is automattically assumed to be the 
            terms and conditions acceptance button.

            the default value for the checkbox is `on`.
            
            If a checkbox is unchecked when its form is submitted, there is no value submitted to
            the server to represent its unchecked state (e.g. value=unchecked); the value is not
            submitted to the server at all.
            
            https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/checkbox */}
            {buttonOnly ? (
                <input
                    type="hidden"
                    name="accept_terms_policy"
                    value={JSON.stringify("on")}
                />
            ) : null}
            <button type="submit" className={buttonClasses.join(" ")} disabled={props.disabled || props.isLoading}>
                {buttonText}
            </button>
            {buttonPrivacyText && (
                <div
                    className={styles.callToActionPrivacyText}
                    dangerouslySetInnerHTML={{
                        __html: buttonPrivacyText,
                    }}
                ></div>
            )}
        </div>
    );
};
